module.exports = __webpack_public_path__ + "img/长图_画板 1.9ae3484a.png";